import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMachineApi } from "../../services/machine/update.machine.api";

export const useUpdateMachineApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoUpdate: any) => updateMachineApi(infoUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-machine-of-store"],
      });
    },
  });
};
